/**
 * 탭뷰 팁 카탈로그 (tips.tsv → generated/tips.json 재구성).
 * 각 탭뷰 하단(제목 아래)에 표시할 짧은 팁/설명 메타 — 본문은 i18n 키(messageKey)로 분리,
 * language_*.tsv에 저장한다(tutorialScenarios.tsv 동일 패턴). 팁 추가는 tips.tsv + language 본문 후
 * `npm run export:data`. scope는 `tab` 컬럼으로 분류(탭별만, 공통 풀 없음).
 */
import tipsJson from "./generated/tips.json";

/** 팁 1행 — id(고유), tab(scope), messageKey(본문 i18n 키). */
export interface TipDef {
  readonly id: string;
  readonly tab: string;
  readonly messageKey: string;
}

const TIPS: readonly TipDef[] = tipsJson as readonly TipDef[];

/** 해당 탭의 팁 목록 — tips.tsv 행 순서 보존. 없으면 빈 배열. */
export function tipsForTab(tab: string): TipDef[] {
  return TIPS.filter((row) => row.tab === tab);
}
